import { render, staticRenderFns } from "./splashsync_products.vue?vue&type=template&id=c6dd815a"
import script from "./splashsync_products.vue?vue&type=script&lang=js"
export * from "./splashsync_products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports